var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape3B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_c_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M380.9,275c-0.1,0.1-0.1,0.1-0.2,0.2c4,1.1,7.2,1.8,11.4,2.5c4.5,0.7,10.2,1.2,14.7,1.4 c1.9,0.1,3.7,0.1,5.5,0c7.3-2.2,12.5-7.4,14.3-14.7C411.5,262.9,388.9,261.6,380.9,275z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#664124",
    d: "M392.7,266c0.1,5.6,4.6,10.1,10.1,10.1c5.6,0,10.1-4.7,10.1-10.4c0-0.8-0.1-1.5-0.2-2.3 C405.7,263.4,398.7,264,392.7,266z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020805",
    d: "M429.2,262.2c-12.9-2.5-41.9-4.3-49.5,11.4c-0.7,1.4,0.5,2.6,1.2,1.4c8-13.5,30.5-12.2,45.8-10.6 c-1.8,7.3-7.1,12.6-14.5,14.7c8.4,0,14.7-7.2,16.9-14.5C430.4,264.7,431,262.6,429.2,262.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020805",
    d: "M398.4,265.5c0,2.3,2,4.1,4.4,4.1s4.4-1.8,4.4-4.1c0-0.7-0.2-1.3-0.5-1.9c-2.7,0.1-5.5,0.4-8.1,0.9 C398.5,264.8,398.4,265.2,398.4,265.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M335,274.5c0.1,0.1,0.1,0.1,0.2,0.2c-4,1.1-7.2,1.8-11.4,2.5c-4.5,0.7-10.2,1.2-14.7,1.4 c-1.9,0.1-3.7,0.1-5.5,0c-7.3-2.2-12.5-7.4-14.3-14.7C304.4,262.3,327,261.1,335,274.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#664124",
    d: "M323.2,265.5c-0.1,5.6-4.6,10.1-10.1,10.1c-5.6,0-10.1-4.7-10.1-10.4c0-0.8,0.1-1.5,0.2-2.3 C310.2,262.9,317.3,263.4,323.2,265.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020805",
    d: "M286.7,261.7c12.9-2.5,41.9-4.3,49.5,11.4c0.7,1.4-0.5,2.6-1.2,1.4c-8-13.5-30.5-12.2-45.8-10.6 c1.8,7.3,7.1,12.6,14.5,14.7c-8.4,0-14.7-7.2-16.9-14.5C285.5,264.1,284.9,262,286.7,261.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020805",
    d: "M317.5,265c0,2.3-2,4.1-4.4,4.1s-4.4-1.8-4.4-4.1c0-0.7,0.2-1.3,0.5-1.9c2.7,0.1,5.5,0.4,8.1,0.9 C317.4,264.3,317.5,264.6,317.5,265z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape3B);
export default __webpack_public_path__ + "static/media/eyeshape_3b.fa7ef1f1dc6f965f1d879d8dff27490b.svg";
export { ForwardRef as ReactComponent };